function sortUser(prop, u1, u2, asc) {
  let e1 = u1[prop].toLowerCase()
  let e2 = u2[prop].toLowerCase()
  if (asc === 1) {
    return e1 < e2 ? -1 : e1 > e2 ? 1 : 0
  } else {
    return e2 < e1 ? -1 : e2 > e1 ? 1 : 0
  }
}

function sortByLastLogin(u1, u2, asc) {
  let date1 = u1.lastLogin
  let date2 = u2.lastLogin
  if (asc === 1) {
    if (!date1 && !date2) {
      return -1
    }
    if (!date1) return 1
    if (!date2) return -1
    return date2 < date1 ? -1 : date2 > date1 ? 1 : 0
  } else {
    if (!date1 && !date2) {
      return -1
    }
    if (!date1) return -1
    if (!date2) return 1
    return date1 < date2 ? -1 : date1 > date2 ? 1 : 0
  }
}

function sortUsers(users, fetchOptions) {
  if (!users) return
  let sort = fetchOptions.sort
  let key = Object.keys(sort)[0]
  users.sort((u1, u2) => {
    switch (key) {
      case 'firstname':
      case 'lastname':
      case 'email':
        return sortUser(key, u1, u2, sort[key])
      case 'lastLogin':
        return sortByLastLogin(u1, u2, sort[key])
      default:
        return sortUser(key, u1, u2, sort[key])
    }
  })
}

export default sortUsers



// WEBPACK FOOTER //
// ./src/modules/user/computed/sortUsers.js